import React, { useState } from 'react';
import cn from 'classnames';

import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';

import './PasswordField.scss';

type Props = {
  name: string;
  value: string;
  placeholder: string;
  labelMuted?: boolean;
  label?: string;
  className?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function PasswordField({ name, value, onChange, placeholder, label = '', labelMuted = false, className = '' }: Props) {
  const [type, setType] = useState('password');

  const handleTypeToggle = () => setType(currentType => (currentType === 'password' ? 'text' : 'password'));

  return (
    <div className="password-field d-flex flex-column mb-3 w-100">
      <span className={cn('password-field-label', { 'password-field-label--muted': labelMuted })}>{label}</span>
      <div className="position-relative">
        <input
          className={`form-control ${className}`}
          type={type}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
        <div className="password-field-eye h-100 d-flex align-items-center">
          <WpButton variant="tertiary" onClick={handleTypeToggle}>
            <WpIcon name={type === 'password' ? 'eye-slash' : 'eye'} />
          </WpButton>
        </div>
      </div>
    </div>
  );
}

export default PasswordField;
